import React from "react";
import Login from "components/Login";
import { isLoggedIn } from "services/auth_service";

function RequireAuth({ children, refresh }) {
  if (!isLoggedIn()) {
    return <Login refresh={refresh} />;
  }

  return children;
}

export default RequireAuth;
